import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

interface FileDropzoneProps {
  onFileUpload: (file: File) => void;
  isLoading?: boolean;
  acceptedFileTypes?: string[];
}

const FileDropzone: React.FC<FileDropzoneProps> = ({ 
  onFileUpload, 
  isLoading = false,
  acceptedFileTypes = ['.csv', '.xlsx', '.xls'] 
}) => {
  const [isDragActive, setIsDragActive] = useState(false);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      onFileUpload(acceptedFiles[0]);
    }
  }, [onFileUpload]);

  const { getRootProps, getInputProps } = useDropzone({ 
    onDrop,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls']
    },
    multiple: false,
    onDragEnter: () => setIsDragActive(true),
    onDragLeave: () => setIsDragActive(false)
  });

  return (
    <div 
      {...getRootProps()} 
      className={`border-2 border-dashed p-8 rounded-lg text-center cursor-pointer transition duration-200 ${
        isDragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-400'
      }`}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center justify-center">
        {isLoading ? (
          <>
            <div className="text-blue-500 text-3xl mb-3 animate-spin">
              ⟳
            </div>
            <p className="text-gray-600">Processing file...</p>
          </>
        ) : (
          <>
            <div className="text-blue-500 text-3xl mb-3">
              📄
            </div>
            <p className="font-medium text-gray-700 mb-1">Drag & drop a file here, or click to select</p>
            <p className="text-sm text-gray-500">
              Supported formats: {acceptedFileTypes.join(', ')}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default FileDropzone; 